export default __webpack_public_path__ + "locales/ro/Errors.json?hash=3327749bddc673593bcea8d9d0f210a6";